import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

import { DialogService } from '@platform/dialog/dialog.service';

import { ProfilePictureUploadDialogComponent } from './profile-picture-upload-dialog/profile-picture-upload-dialog.component';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styles: [],
})
export class FileUploadComponent {
  @Input() label = 'action';
  @Output() filesUploaded = new EventEmitter<FileList>();

  constructor(
    private dialogService: DialogService,
    private translateService: TranslateService,
  ) {}

  public openDialog(): void {
    this.dialogService
      .openDialog(ProfilePictureUploadDialogComponent, {
        width: '800px',
        autoFocus: false,
        disableClose: true,
      })
      .pipe(filter((data) => !!data))
      .subscribe((data) => this.filesUploaded.emit(data as FileList));
  }

  public getTranslatedLabel() {
    return this.translateService.instant(`file-upload.${this.label}`);
  }
}
